import { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Alert, Box, Container, Snackbar } from '@mui/material';
import TrainerResults from 'src/components/trainer/TrainerListResults';
import { deleteTrainer, getTrainer } from 'src/api/trainer';
import { CONSTANTS, STRINGS } from 'src/commons';
import Toolbar from 'src/components/trainer/Toolbar';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { commonReducerAction } from 'src/redux/reducers/common';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { trainersReducerAction } from 'src/redux/reducers/trainer';
import { debounce } from 'src/utils/debounce';
import ConfirmDialog from '../../components/ConfirmationBox';

const Trainer = () => {
  const { startLoading, stopLoading } = loaderReducerAction;
  const [trainers, setTrainers] = useState([]);
  const history = useNavigate();
  const dispatch = useDispatch();
  const { user, gymId } = useSelector((state) => state.common);
  const { updateTrainers } = trainersReducerAction;
  const { logoutUser } = commonReducerAction;
  const [searchLoader, setSearchLoader] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteTrainerData, setDeleteTrainerData] = useState({});
  const [deleting, setDeleting] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  const fetchTrainers = () => {
    dispatch(startLoading());
    getTrainer(user, gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN) logoutUser();
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          setTrainers(res.data);
          dispatch(updateTrainers(res.data));
        }
        dispatch(stopLoading());
      })
      .catch((err) => {
        dispatch(stopLoading());
        console.log(err);
      });
  };

  useEffect(() => {
    fetchTrainers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onClickRow = (item) => {
    history(CONSTANTS.ROUTES.PRIVATE_ROUTES.EDIT_TRAINER + '/' + item._id);
  };

  const onDelete = (item) => {
    dispatch(startLoading());
    setDeleting(true);
    deleteTrainer(user, item._id)
      .then((res) => {
        if (res?.status === 200) {
          setSnackbarState({
            open: true,
            message: 'Trainer deleted successfully',
            severity: 'success'
          });
        } else if (res?.status !== 200) {
          setSnackbarState({
            open: true,
            message: res?.message || 'Something went wrong',
            severity: 'error'
          });
        }
        setDeleting(false);
        setDeleteModal(false)
        fetchTrainers();
      })
      .catch((err) => {
        setSnackbarState({
          open: true,
          message: err?.message || 'Something went wrong',
          severity: 'error'
        });
        console.log(err);
        setDeleting(false);
        setDeleteModal(false)
      });
  };

  const filterItem = debounce((text) => {
    setSearchInput(text?.trim());
  }, 200);

  const parsedData = useMemo(() => {
    setSearchLoader(true);
    const filteredData = trainers?.filter((trainer) =>
      trainer?.name?.toLowerCase()?.includes(searchInput.toLowerCase())
    );
    setSearchLoader(false);
    return filteredData;
  }, [searchInput, trainers]);

  return (
    <>
      <Helmet>
        <title>Members | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            searchLoader={searchLoader}
            filterItem={filterItem}
            text={STRINGS.ADD_TRAINER}
            route={CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_TRAINER}
          />
          <Box sx={{ pt: 3 }}>
            <TrainerResults
              trainers={parsedData}
              onEdit={onClickRow}
              onDelete={(item) => {
                setDeleteTrainerData(item);
                setDeleteModal(true);
              }}
            />
          </Box>
        </Container>
      </Box>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <div>
          <Alert onClose={handleClose} severity={snackbarState.severity}>
            {snackbarState.message}
          </Alert>
        </div>
      </Snackbar>
      <ConfirmDialog
        heading={'Delete  Trainer'}
        message={'Do you want to delete the trainer?'}
        open={deleteModal}
        handleClose={() => {
          setDeleteModal(false);
        }}
        handleConfirm={() => {
          onDelete(deleteTrainerData);
        }}
        loading={deleting}
        key={'detete modal'}
      />
    </>
  );
};

export default Trainer;
